export const FirebaseConfig = {
	"projectId": "minas-car-app",
	"appId": "1:206683174745:web:bec77a8fa64b3838767e48",
	"databaseURL": "https://minas-car-app-default-rtdb.firebaseio.com",
	"storageBucket": "minas-car-app.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyAIX4Cw0vTlYchtrHB3ss3kuxXkR4kKzGQ",
	"authDomain": "minas-car-app.firebaseapp.com",
	"messagingSenderId": "206683174745",
	"measurementId": "G-W4QRHWHT02",
	"projectNumber": "206683174745",
	"version": "2"
};